import  React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button } from 'antd';
import api from '../../api';
import helpers from '../../helpers'
import FaIcon from '../global/fa-icon/fa-icon';
import CustomDataTable from '../custom-data-table/custom-data-table';
import MoviePosterImage from '../movie-poster-image/movie-poster-image.component';



let _pageNumOffset = 1;

let _paginationOpts = {
  l: 10,
};


class RecentMovies extends Component {

  // NOTE: if you extend propTypes directly in child component class, you will get a react warning.  use _propTypes alias instead
  static propTypes = {
    onItemClicked: PropTypes.func,
  };

  static defaultProps = {
    onItemClicked: null,
  };

  constructor(props) {
    super(props);

    this.movieHelper = helpers.movie;

    let pageData = CustomDataTable.EmptyPageData;
    pageData.maxItemsPerPage = _paginationOpts.l;
    pageData.activePageIdx = 0;
    pageData.firstPageIdx = 0;
    pageData.lastPageIdx = 0;
    // pageData.pageDisplayOffset = 0;

    let sortData = CustomDataTable.EmptySortData;

    this.state = {
      items: null,
      pageData: pageData,
      sortData: sortData,
      tableSearch: null,
      // tableSort: null,
      // tablePage: null,
    };


    this.columnHeaders = [
      {
        label: '',
        field: null,
        formatter: this.renderMovieItemCell.bind(this),
        sort: 'asc',
        width: 250
      },
    ];

    this.handleSearchChanged = this.handleSearchChanged.bind(this);
    this.handleSortChanged = this.handleSortChanged.bind(this);
    this.handlePageChanged = this.handlePageChanged.bind(this);
    this.handleRowClicked = this.handleRowClicked.bind(this);
    this.invalidateData = this.invalidateData.bind(this);

    this.invalidateData();
  }

  handleSearchChanged(e) {
    // console.log('handleSearchChanged: ' + JSON.stringify(e));
    this.setState({ tableSearch: e }, this.invalidateData);
  }

  handleSortChanged(e) {
    // console.log('handleSortChanged: ' + JSON.stringify(e));

    if (!_.isEqual(this.state.sortData, e)) {
      let sortData = _.cloneDeep(this.state.sortData);

      // TODO: joe- handle this case

      this.setState({ sortData }, this.invalidateData);
    }
  }

  handlePageChanged(e) {
    // console.log('handlePageChanged: ' + JSON.stringify(e));

    if (this.state.pageData.activePageIdx !== e.activePageIdx) {
      let pageData = _.cloneDeep(this.state.pageData);
      pageData.activePageIdx = e.activePageIdx;

      this.setState({ pageData }, this.invalidateData);
    }
  }

  handleRowClicked(row) {
    // navigate to edit page
    // let id = _.get(movieItem, 'id', null);
    // this.props.history.push('/movies/edit/' + id);
    if (this.props.onItemClicked) {
      this.props.onItemClicked(row);
    }
  }

  invalidateData() {
    let q = {};
    q = _.extend(q, _paginationOpts);

    q.p = (this.state.pageData.activePageIdx || 0) + _pageNumOffset;

    if (this.state.tableSearch && !_.isEmpty(this.state.tableSearch)) {
      q.f = 'title|' + this.state.tableSearch;
      q.p = _pageNumOffset;    // revert to first page when searching
    }

    // sort field and sort order
    if (this.state.tableSort) {
      q.sf = _.replace(this.state.tableSort.column, /_?Formatted$/i, '');
      q.so = this.state.tableSort.direction || 'asc';
    } else {
      q.sf = 'release_date';
      q.so = 'desc';
    }

    if (this.prevQuery && _.isEqual(this.prevQuery, q)) {
      return false;
    }
    this.prevQuery = q;


    return api.movies.find(q).then(res => {
      let items = _.get(res, 'data') || null;
      let pageData = _.cloneDeep(this.state.pageData);

      let meta = _.get(res, 'meta') || null;
      if (meta) {
        pageData.activePageIdx = meta.pageNumber - _pageNumOffset;
        pageData.numItems = meta.totalRecords;
        pageData.numTotalPages = meta.totalPages;
        pageData.numTotalItems = meta.totalRecords;
        pageData.lastPageIdx = pageData.numTotalPages - 1;
      }

      this.setState({ items, pageData });
      return true;
    });
  }

  renderMovieItemCell = (__ignoredValue, row, rowIdx) => {
    let movie = row || {};
    return (
      <div className="movie-title-preview d-flex flex-row">
        <div className="d-flex flex-fill flex-row">
          <MoviePosterImage movie={movie} resolutionSize="50x50" />
          <div className="d-flex flex-column ml-3">
            <div className="movie-title">{movie.title}</div>
            <div className="movie-release-date">{this.movieHelper.formatDateValue(movie.release_date, 'ddd M/D/YYYY')}</div>
          </div>
        </div>
        <div className="actions float-right mt-1">
          <Button type="primary" size="large" shape="circle" icon={<FaIcon icon="fa-plus" />} onClick={() => this.handleRowClicked(row)} />
        </div>
      </div>
    );
  };


  render() {

    let tableData = this.state.items;
    let sortData = this.state.sortData;
    let pageData = this.state.pageData;

    return (
      <div className="recent-movies">

        <h2 className="text-center">Recent Movies</h2>

        <CustomDataTable
          striped={true}
          showSearch={true}
          showSort={false}
          showPaging={true}

          onSearchChanged={this.handleSearchChanged}
          onSortChanged={this.handleSortChanged}
          onPageChanged={this.handlePageChanged}

          headers={this.columnHeaders}
          data={tableData}

          searchLabel={''}
          sortData={sortData}
          pageData={pageData}
          paginationSimpleMode={true}
          paginationSize="small"
        />

      </div>
    );
  }
}

export default RecentMovies;

